/**
 * @generated SignedSource<<40cc267bb0805fea5ee0defc8f48b1df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FiatPayoutViewQuery$variables = Record<PropertyKey, never>;
export type FiatPayoutViewQuery$data = {
  readonly fiatWallet: {
    readonly balance: PrecisionFloat;
    readonly unconfirmed: PrecisionFloat;
    readonly withdrawable: PrecisionFloat;
  } | null | undefined;
  readonly payoutAccounts: ReadonlyArray<{
    readonly bankName: string | null | undefined;
    readonly iban: string;
    readonly id: string;
    readonly name: string | null | undefined;
  }> | null | undefined;
};
export type FiatPayoutViewQuery = {
  response: FiatPayoutViewQuery$data;
  variables: FiatPayoutViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FiatWallet",
    "kind": "LinkedField",
    "name": "fiatWallet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "withdrawable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unconfirmed",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PayoutAccount",
    "kind": "LinkedField",
    "name": "payoutAccounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bankName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iban",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FiatPayoutViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FiatPayoutViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f0d590b3ed037cb0fe393a5c68f72049",
    "id": null,
    "metadata": {},
    "name": "FiatPayoutViewQuery",
    "operationKind": "query",
    "text": "query FiatPayoutViewQuery {\n  fiatWallet {\n    balance\n    withdrawable\n    unconfirmed\n  }\n  payoutAccounts {\n    id\n    name\n    bankName\n    iban\n  }\n}\n"
  }
};
})();

(node as any).hash = "20f6a360504f71baae1c44842f60b53b";

export default node;
